import {
  SessionStorageKey,
  getFromSessionStorage,
  removeSessionStorage,
  setInSessionStorage,
} from "../../../utils/sessionStorage";

/**
 * Most state from the web booking flow is stored in the query string, which supports
 * deeplinks and makes the page behave well with refreshes, back, and forward buttons.
 *
 * ...however the user's email is PHI. Query params are stored in the browser history,
 * which can leak PHI on shared computers... so we use SessionStorage instead.
 */

/**
 * clearEmail sets the value to an empty string in sessionStorage. It does this rather than
 * removing it altogether because web booking wants to re-render the account_selection screen
 * if the user clicks "back" on the account_creation one, and browsers don't emit a storage
 * change event if the value is removed altogether.
 */
export const clearEmail = () => removeSessionStorage(SessionStorageKey.WebBookingEmail);

export const getEmail = () => getFromSessionStorage(SessionStorageKey.WebBookingEmail);

export const setEmail = (email: string) =>
  setInSessionStorage(SessionStorageKey.WebBookingEmail, email);

// Storing this in a separate key for the patient app solves two issues:
//   1. The PHI entry screen shouldn't show before redirecting to the patient app.
//   2. The "back" button should return users to the email entry screen.
export const setEmailForPatientApp = (email: string) =>
  setInSessionStorage(SessionStorageKey.WebBookingPatientAppEmail, email);
